import React from 'react';
import { FaDownload } from 'react-icons/fa6';
import { ReportFilterModel } from './ReportFilter';
import List from '../Crud/List';
import CustomButton from '../CustomButton/CustomButton';

type ReportDataItem = {
  time: string;
  title: string;
  filters: ReportFilterModel[];
  header: Array<{ name: string; label: string; type: string }>;
  body: Array<any>;
  footer: Array<any>;
};

type ReportDataProps = {
  isLoading: boolean;
  data: ReportDataItem | undefined;
};

export default function ReportData({ isLoading, data }: ReportDataProps) {
  function extracted(
    header: { name: string; label: string; type: string },
    row: any
  ) {
    if (header.type === 'date') {
      return new Date(row[header.name])
        .toLocaleDateString('pt-BR')
        .replace(',', '');
    }

    if (header.type === 'datetime') {
      return new Date(row[header.name])
        .toLocaleString('pt-BR')
        .replace(',', '');
    }

    return row[header.name] !== null ? row[header.name] : '-';
  }

  const exportToCsv = async () => {
    if (!data) {
      alert('Houve um erro ao exportar o arquivo');
      return;
    }

    try {
      const csvData = [
        data.header.map((h: any) => h.label).join(','),
        ...data.body.map((b: any) => {
          return data.header.map((h: any) => b[h.name]).join(',');
        }),
      ].join('\n');

      const blob = new Blob([csvData], { type: 'text/csv' });
      const href = URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = href;
      link.setAttribute('download', `${data.title} ${data.time}.csv`);

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(href);
    } catch (error) {
      alert('Houve um erro ao exportar o arquivo');
      console.error('Failed to export csv file:', error);
      throw error;
    }
  };

  return (
    <>
      {data && (
        <div className='w-100 d-flex justify-content-between align-items-center'>
          <div>Registros encontrados: {data?.body?.length ?? 0}</div>
          <CustomButton
            className='btn btn-success'
            type='button'
            handleClick={exportToCsv}
          >
            <FaDownload />
          </CustomButton>
        </div>
      )}
      <List isLoading={isLoading} title='' newItemUrl='' withNewAction={false}>
        <table className='table table-sm table-hover'>
          <thead>
            <tr>
              {data?.header.map((header: any) => (
                <th
                  key={header.name}
                  className={header.type === 'int' ? 'text-end' : ''}
                >
                  {header.label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {(data?.body.length ?? 1) > 0 ? (
              data?.body?.map((row: any) => (
                <tr key={`row_${row.index}`}>
                  {data?.header?.map((header) => (
                    <td
                      key={`col_${row.index}_${header.name}`}
                      className={header.type === 'int' ? 'text-end' : ''}
                    >
                      {extracted(header, row)}
                    </td>
                  ))}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={data?.header.length || 1} className='text-center'>
                  <i>(Nenhum resultado encontrado)</i>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </List>
    </>
  );
}
